import React from "react";
import styled from "styled-components";

import { useQuery } from "styles/breakpoints";
import { tablet } from "styles/breakpoints";

import { FlexWrapper, H4, Image, ContainerMedium } from "components";
import { black50, black100 } from "styles/colors";

interface Props {
  children?: React.ReactNode;
  justifyContent?: string;
  boxShadow?: string;
}

export const Header: React.FC<Props> = ({
  children,
  boxShadow,
  justifyContent,
}) => {
  const { isTablet } = useQuery();
  
  return (
    <Wrapper boxShadow={boxShadow}>
      <ContainerMedium>
        <FlexWrapper
          margin='0 auto'
          justifyContent={justifyContent}
          alignItems='center'
        >
          <FlexWrapper alignItems='center'>
            <Image src='controller' maxWidth='9.3125rem' maxHeight='2.5rem' />
            <H4 margin={isTablet ? "0 0 0 0.5rem" : "0 0 0 1.5rem"}>
              Play Everywhere!
            </H4>
          </FlexWrapper>
          {children}
        </FlexWrapper>
      </ContainerMedium>
    </Wrapper>
  );
};

interface Props {
  boxShadow?: string;
}

const Wrapper = styled.nav<Props>`
  position: fixed;
  top: 0;
  padding: 1rem;
  width: 100%;
  background-color: #6c4970;
  background-image: linear-gradient(315deg, #6c4970 0%, #185079 74%);
  box-shadow: ${({ boxShadow }) => boxShadow || `0 0.5rem 1.5rem ${black50}`};
  z-index: 10;

  @media ${tablet} {
    box-shadow: ${({ boxShadow }) =>
      boxShadow || `0 0.5rem 1.5rem ${black100}`};
  }
`;
